import React, { useState } from "react";
import { withRouter } from "next/router";
import { WithRouterProps } from "next/dist/client/with-router";
import Logo from '../../../../public/images/logo-new.svg';
import { BasicInfoContainer, ImageContainer, Title, FieldsContainer, NameInputContainer, CustomSubmitButton, AlreadyMemberButton, StyledLink } from "./BasicInfo.styles";
import { Checkbox, InfoMessage, TextField } from "../..";
import { CTAForthContainer } from "../../../pages/Register/Register.styles";
import { emailValidation } from "../../../utils/regex";
import { RegisterBasicInfoInterface } from "../../../models/Register";
import { registerBasicInfo } from "../../../services/AuthenticationService";
import { useRegisterContext } from "../../../contexts/RegisterContext";

interface BasicInfoProps extends WithRouterProps {
    onNextButtonClick: Function;
}

const BasicInfo: React.FC<BasicInfoProps> = ({
    onNextButtonClick
}) => {
    const { setRegisterInfo } = useRegisterContext();

    const [email, setEmail] = useState<string>("");
    const [firstName, setFirstName] = useState<string>("");
    const [lastName, setLastName] = useState<string>("");
    const [isTTTAgreed, setIsTTTAgreed] = useState<boolean>(false);

    const [emailError, setEmailError] = useState<boolean>(false);
    const [registerError, setRegisterError] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState("");

    const [loading, setLoading] = useState<boolean>(false);

    const isSubmitButtonDisabled = () => {
        return !isTTTAgreed || !email || !firstName || !lastName
    }

    const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setEmail(event.target.value);
        setEmailError(false);
        setRegisterError(false);
    }

    const handleRegister = () => {
        if (!emailValidation(email)) {
            setEmailError(true);
            setRegisterError(true);
            setErrorMessage("Oops! Your email appears to be in the wrong format.");
            return;
        }
        setEmailError(false);
        setRegisterError(false);
        setLoading(true);
        let registerData: RegisterBasicInfoInterface = {
            user: {
                email: email,
                firstName: firstName,
                lastName: lastName,
            }
        };

        registerBasicInfo(registerData).then((res) => {
            if (res.status == 400) {
                setRegisterError(true);
                setErrorMessage(res.errors?.message[0]);
            } else if (res.status == 200) {
                onNextButtonClick();

                setRegisterInfo(prevRegisterInfo => ({
                    ...prevRegisterInfo,
                    user: {
                        ...prevRegisterInfo.user,
                        ...registerData.user
                    }
                }))
            }
            setLoading(false);
        });
    }

      const registerNameMessage = "This is the name that will appear on your ticket. Please enter your name as it appears on your ID. Some shows may require you to present identification to enter."
      const registerEmailMessage = "This is the email address your tickets will be sent to. Please use a personal email address you have access to at all times. You never know when an important update or ticket offer may be sent!"

    return (
        <BasicInfoContainer>
            <ImageContainer>
                <Logo />
            </ImageContainer>
            {!email && <Title>
                My name is...<br/>
            </Title>}
            <FieldsContainer>
                <NameInputContainer>
                    <TextField
                        data-cy="register-first-name"
                        autoFocus
                        value={firstName}
                        onChange={(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => setFirstName(event.target.value)}
                        placeholder="First Name"
                        size="lg" />
                    <TextField
                        data-cy="register-last-name"
                        value={lastName}
                        onChange={(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => setLastName(event.target.value)}
                        placeholder="Last Name"
                        size="lg" />
                </NameInputContainer>
                {firstName && lastName && !email &&
                (<InfoMessage
                  data-cy="name-register-info"
                  variant="info"
                  hasBackground={true}
                  message={registerNameMessage}
                />)}

            {email && !isTTTAgreed &&
            (<Title><br/>Enter Your Email Address<br/><br/></Title>)
            }
                <TextField
                    data-cy="register-email"
                    fullWidth
                    error={emailError}
                    value={email}
                    onChange={handleEmailChange}
                    placeholder="Email"
                    size="lg" />
                {registerError && (
                    <InfoMessage
                        data-cy="register-error"
                        variant="error"
                        hasBackground={true}
                        message={errorMessage}
                    />
                )}
                {email && !isTTTAgreed &&
                  <InfoMessage
                  data-cy="email-register-info"
                  variant="info"
                  hasBackground={true}
                  message={registerEmailMessage}
                  />}
                <Checkbox
                    data-cy="register-tc-checkbox"
                    checked={isTTTAgreed}
                    onChange={setIsTTTAgreed}
                    label={
                        <>
                            I agree to TTT’s {" "}
                            <StyledLink
                                target="_blank"
                                href="https://www.thatstheticket.com.au/_files/ugd/e9ec41_6389a51e79cb4768a2027f293c0b6dd0.pdf"
                            >
                                Privacy Policy and Collection Statement.
                            </StyledLink>
                            &nbsp;
                            <br/>*Fear not! We don't sell or share your contact details with anyone.
                        </>
                    }
                />
            </FieldsContainer>
            <CTAForthContainer>
                <CustomSubmitButton
                    data-cy="register-basic-info-submit"
                    onClick={handleRegister}
                    disabled={isSubmitButtonDisabled()}
                    disabledStateStyling="lowOpacity"
                    full
                    loading={loading}
                >
                    Join Us
                </CustomSubmitButton>
            </CTAForthContainer>
            <AlreadyMemberButton>Already a Member? <StyledLink href="/login">Login</StyledLink></AlreadyMemberButton>
        </BasicInfoContainer>
    );
};

BasicInfo.displayName = "BasicInfo";

const ComponentWithRouter = withRouter(BasicInfo)

export { ComponentWithRouter as BasicInfo };